module.exports = __webpack_public_path__ + "static/media/sss.1c7ec61b.svg";